import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableRowWrap: {
      position: 'relative',
      '&:nth-child(odd) > $tableRow': {
        background: colorsPalette.violetAnalyticsCard,
      },
    },
    tableRow: {
      display: 'flex',
      alignItems: 'center',
      color: colorsPalette.gray,
      fontSize: 14,
      lineHeight: 1.4,
      minHeight: 64,
      background: theme.palette.secondary.main,
    },
    tableCells: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      padding: '14px 0',
      justifyContent: 'space-between',
      [theme.breakpoints.up('md')]: {
        width: 'calc(100% - 46px)',
      },
      '& > .hidden-on-mobile': {
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
    },
    tableCellHiddenOnMobile: {
      [theme.breakpoints.down('lg')]: {
        display: 'none',
      },
    },
    dotsBtn: {
      padding: 9,
    },
    dropdown: {
      background: theme.palette.secondary.main,
      position: 'relative',
      width: '100%',
      transition: 'all .5s ease-in-out',
      display: 'none',
      '&$dropdownOpened': {
        display: 'block',
      },
      [theme.breakpoints.up('md')]: {
        borderRadius: 10,
        background: colorsPalette.violetAnalyticsCard,
        zIndex: 1150,
        boxShadow: `0px 13px 26px ${fade(colorsPalette.blackPure, 0.3)}`,
        minWidth: 255,
        maxWidth: 255,
        position: 'absolute',
        right: -2,
        top: 60,
      },
    },
    dropdownOpened: {},
    dropdownContent: {
      position: 'relative',
      '&::before': {
        content: '""',
        display: 'block',
        width: 18,
        height: 18,
        background: colorsPalette.violetAnalyticsCard,
        transform: 'rotate(45deg)',
        position: 'absolute',
        top: -9,
        right: 17,
      },
    },
    dropdownList: {
      listStyle: 'none',
      margin: 0,
      padding: '12px 0',
      overflow: 'hidden',
      [theme.breakpoints.up('md')]: {
        '& > li': {
          padding: '9px 32px',
        },
      },
      '& > li': {
        fontSize: 14,
        padding: '9px 24px',
        width: '100%',
        fontWeight: 700,
        textTransform: 'uppercase',
        transition: 'all .3s',
        cursor: 'pointer',
        '&:hover': {
          background: theme.palette.secondary.main,
        },
        '& > a': {
          color: colorsPalette.white,
        },
      },
    },
  }),
);

export default useStyles;
